<template>
  <div>
    <Card
      v-for="parkingArea in parkingAreas"
      :key="parkingArea.parkingAreaID">
      <template slot="header">
        {{ parkingArea.parkingName }}
      </template>

      <v-layout
        align-center
        justify-center
        row
        wrap>
        <v-flex xs3>
          Price/Day: ${{ settings.parkingPrice }}
        </v-flex>
        <v-flex>
          <!--details go here -->
        </v-flex>
        <v-flex xs3>
          <!-- icons go here -->
        </v-flex>
      </v-layout>
      <v-layout
        align-center
        row
        wrap>
        <v-flex
          v-for="(day, index) in week"
          :key="index"
          :class="{'hidden-sm-only' : index >= 5, 'hidden-xs-only': index >= 3}"
          class="my-4"
        >
          <ReserveBlock>
            <template slot="header">
              {{ day.format('ddd') }}<br>
              {{ day.format('YYYY-MM-DD') }}
            </template>
            <!-- start reserved -->
            <ParkingReserveIcon
              :reserve-date="day"
              :rolling-date="rollingDate"
              :current-datetime="currentDatetime"
              :vehicle-i-d="searchCriteria.vehicleID"
              :vehicle-in-state="vehicleInState"
              :parking-area-i-d="parkingArea.parkingAreaID"
              :open-date="$moment(day.year() + parkingArea.openDate.substring(4))"
              :close-date="$moment(day.year() + parkingArea.closeDate.substring(4))"
              :capacity="parkingArea.parkingCapacity"
              :bookings="parkingArea.bookings"
              :blackouts="parkingArea.blackouts"
              :utilization="parkingArea.utilization"
            />
          </ReserveBlock>
        </v-flex>
      </v-layout>
    </Card>
  </div>
</template>

<script>
// import vuex mapping
import { mapActions, mapGetters } from 'vuex'
import ParkingReserveIcon from './ParkingReserveIcon'
// our new component
export default {
  components: {
    ParkingReserveIcon
  },
  data () {
    return {
      processing: false
    }
  },
  computed: {
    ...mapGetters({
      parkingAreas: 'facilities/parkingAreas',
      searchCriteria: 'facilities/searchCriteria',
      vehicles: 'vehicles/vehicles'
    }),
    week () {
      // reload every time this is computed
      this.getParkingWeek()
      var week = []
      // derive the week
      for (var i = 0; i <= 6; i++) {
        var dateObject = this.$moment.tz(this.searchCriteria.date, 'America/New_York').add(this.settings.miscCloseTime, 'hours')
        dateObject.add(i, 'days')
        week.push(dateObject)
      }
      return week
    },
    currentDatetime () {
      return this.$moment.tz('America/New_York')
    },
    rollingDate () {
      return this.$moment.tz('America/New_York').add(this.settings.parkingRollingPeriod, 'days')
    },
    vehicleInState () {
      return this.vehicles.find(vehicle => vehicle.vehicleID === this.searchCriteria.vehicleID)?.vehicleState === 'Maine'
    }
  },
  mounted () {
    this.getParkingAreas().then(() => {
      this.parkingWeekPoller = setInterval(this.getParkingWeek, 30000)
    })
  },
  beforeDestroy () {
    clearInterval(this.parkingWeekPoller)
  },
  methods: {
    ...mapActions({
      getParkingAreas: 'facilities/getParkingAreas',
      getParkingWeek: 'facilities/getParkingWeek'
    }),
    remainingSpots (parkingArea, date) {
      return Number(parkingArea.parkingCapacity) - Number(parkingArea.utilization?.[date]?.utilization || 0)
    }
  }
}
</script>
